import { z } from 'zod';

import { UuidSchema } from '../../common/id/id';
import { LikeDecisionSchema } from '../like-decision/like-decision';

/**
 * One member's decision about another.
 *
 * **The actor is not in the body.** It comes from the token, exactly as the
 * verification surface reaches a case without ever naming its id: a request that
 * could say who is liking is a request that could like on somebody else's
 * behalf.
 *
 * **`decision` has no default.** "The client did not say" and "the member
 * passed" are different facts, and defaulting either way would turn a
 * malformed request into a recorded decision the member never made.
 */
export const LikeRequestSchema = z
  .object({
    targetUserId: UuidSchema,
    decision: LikeDecisionSchema,
  })
  .strict();

export type LikeRequest = z.infer<typeof LikeRequestSchema>;
